import React from "react"
import { Box } from "@carrotfertility/carotene-core"
import type { BannerImageNode } from "../renderer/types"

export function BannerImageContent({ content }: { content: BannerImageNode }) {
  return (
    <Box
      component="img"
      src={content.imageUrl}
      alt={content.altText}
      sx={(theme) => ({
        borderRadius: theme.tokens.borderRadius.md,
        marginBlockStart: theme.tokens.spacing.md,
        marginBlockEnd: theme.tokens.spacing.lg
      })}
    />
  )
}
